<form>
  <div class="content-1920">
    <div class="content-padding margin-top-small">
      <div class="main">
        <h2 id="group_blocks_title"></h2>

        <div class="fieldwrap">
          <label>Farms</label>
          <select
            id="farm_name"
            name="farm_name"
            required
            (change)="onSelectFarm($event.target)"
          >
            <option>Select Farm</option>
            @for (f of availableFarms; track f) {
            <option value="{{ f.id }}">
              {{ f.name }}
            </option>
            }
          </select>
        </div>

        <div cdkDropListGroup class="fieldwrap columns3">
          <div class="farm_blocks">
            <label>Farm Blocks</label>
            <div
              cdkDropList
              id="availableBlocksList"
              cdkDropListSortingDisabled
              [cdkDropListData]="availableBlocks"
              class="available-blocks-list"
              (cdkDropListDropped)="drop($event)"
            >
              @for (item of availableBlocks; track item) {
              <div class="blocks-box" cdkDrag>
                {{ item.block_number }}
              </div>
              }
            </div>
          </div>
          <div class="selected_blocks">
            <label>Selected Blocks</label>
            <div
              cdkDropList
              id="assignedBlocksList"
              cdkDropListSortingDisabled
              [cdkDropListData]="assignedBlocks"
              class="assigned-blocks-list"
              (cdkDropListDropped)="drop($event)"
            >
              @for (item of assignedBlocks; track item) {
              <div class="blocks-box" cdkDrag>
                <table style="width: 100%">
                  <tr>
                    @if (item.selected_result && !item.selected_result.standard)
                    {
                    <td>({{ rankings[item.selected_result.ranking] }})</td>
                    } @if (item.selected_result &&
                    item.selected_result.standard) {
                    <td>Standard Practice</td>
                    }
                    <td>Block No: {{ item.block_number }}</td>
                    <td>Area: {{ item.area }} (ha)</td>
                    <!-- <td>
                      Representative Area (ha):
                      {{ item.block_representative_area | number : "1.2-2" }}
                      <a
                        class="btn__secondary btn-calculator"
                        (click)="showAllowance(item.block_number)"
                        >Allowance Calculator</a
                        >
                      </td> -->
                  </tr>
                  @if (item.selected_result) {
                  <tr>
                    <td colspan="3">
                      <table style="width: 100%">
                        @if (item.selected_result.standard) {
                        <ng-container>
                          <tr>
                            <td>
                              Yield (t/ha):
                              {{
                                item.selected_result.block_agronomic_results
                                  .yield_std | number : "1.2-2"
                              }}
                            </td>
                            <td>
                              Fan Speed (RPM):
                              {{
                                item.selected_result.block_agronomic_results
                                  .fan_speed_std | number : "1.0-0"
                              }}
                            </td>
                            <td>
                              Ground Speed (km/hr):
                              {{
                                item.selected_result.block_agronomic_results
                                  .ground_speed_std | number : "1.1-1"
                              }}
                            </td>
                            <td>
                              Flow Rate (t/hr):
                              {{
                                item.selected_result.block_agronomic_results
                                  .flow_rate_std | number : "1.1-1"
                              }}
                            </td>
                            <td>
                              Hours per day (total):
                              {{
                                item.selected_result.block_agronomic_results
                                  .hours_per_day_total_std | number : "1.0-0"
                              }}
                            </td>
                            @if (item.results) {
                            <td>
                              <button
                                class="btn__tertiary"
                                (click)="
                                  block = item.block_number;
                                  block_results = item.results;
                                  dialog_open = true
                                "
                              >
                                Show More
                              </button>
                            </td>
                            }
                          </tr>
                        </ng-container>
                        } @if (!item.selected_result.standard) {
                        <ng-container>
                          <tr>
                            <td>
                              Yield (t/ha):
                              {{
                                item.selected_result.block_agronomic_results
                                  .pred_yield
                              }}
                            </td>
                            <td>
                              Fan Speed(RPM):
                              {{
                                item.selected_result.block_agronomic_results
                                  .fan_speed_pred
                              }}
                            </td>
                            <td>
                              Ground Speed (km/hr):
                              {{
                                item.selected_result.block_agronomic_results
                                  .ground_speed_pred
                              }}
                            </td>
                            <td>
                              Flow Rate (t/hr):
                              {{
                                item.selected_result.block_agronomic_results
                                  .flow_rate_pred
                              }}
                            </td>
                            <td>
                              Hours per day (total):
                              {{
                                item.selected_result.block_agronomic_results
                                  .hours_per_day_total_pred
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Cost Change ($/t):
                              {{
                                item.selected_result
                                  .block_economic_results_grower.cost_change_t
                              }}
                            </td>
                            <td>
                              Cost Change ($/ha):
                              {{
                                item.selected_result
                                  .block_economic_results_grower.cost_change_ha
                              }}
                            </td>
                            <td>
                              Cost Change ($/hr):
                              {{
                                item.selected_result
                                  .block_economic_results_grower.cost_change_hr
                              }}
                            </td>
                            <td>
                              Grower Net Benefit ($/ha):
                              {{
                                item.selected_result
                                  .block_economic_results_grower.net_benefit
                              }}
                            </td>
                            @if (item.results) {
                            <td>
                              <button
                                class="btn__tertiary"
                                (click)="
                                  block = item.block_number;
                                  block_results = item.results;
                                  dialog_open = true
                                "
                              >
                                Show More
                              </button>
                            </td>
                            }
                          </tr>
                        </ng-container>
                        }
                      </table>
                    </td>
                  </tr>
                  }
                </table>
              </div>
              }
            </div>
            @if (!is_processing_calculations) {
            <label
              >Total Representative Area:
              {{ total_representative_area | number : "1.2-2" }} (ha)</label
            >
            } @if (is_processing_calculations) {
            <label>Running calculations...</label>
            }
          </div>
          <div class="calculate_average">
            <label>Average Calculations</label>
            <a class="btn__secondary" (click)="calculate_average()"
              >Calculate Average</a
            >
          </div>
        </div>
        <div class="fieldwrap fieldwrap-type-submit align-right">
          <a
            class="btn__secondary btn-back"
            routerLink="/contract-negotiation-grower"
            [queryParams]="{ id: group_id, name: group }"
            >Back</a
          >
        </div>
      </div>
      <div id="calculator" [ngClass]="{ 'overlay open': allowance_open }">
        <div class="modal-box" style="width: 50%">
          <button
            class="close"
            type="button"
            (click)="allowance_open = false"
          ></button>
          <div class="modal-header">
            <h2>Allowance <strong>Calculator</strong></h2>
            <div class="fieldwrap label-inline">
              This is only used if representative block allowances have not been
              added to the Infield Logistics Section.
            </div>
            <p class="h5">(Harvester / Haulage / Night / Sunday)</p>
          </div>
          <form>
            <fieldset>
              <div class="fieldwrap label-inline">
                <label
                  >Total hectares considered for representive block/area</label
                >
                <app-number-input
                  [(numberInput)]="block_allowance.total_repesentative_area"
                  (numberInputChange)="
                    countAllowanceChangedHandler(
                      $event,
                      'total_repesentative_area'
                    )
                  "
                >
                </app-number-input>
              </div>
              <div class="fieldwrap label-inline">
                <label>Total tonnage (based on block standard yield)</label>
                <app-number-input
                  [numberInput]="block_allowance.delivered_yield_estimate"
                  (numberInputChange)="
                    countAllowanceChangedHandler(
                      $event,
                      'delivered_yield_estimate'
                    )
                  "
                >
                </app-number-input>
              </div>

              <div class="field-group">
                <div class="fieldwrap label-inline">
                  <label>$/t Harvest Allowance (not paid to drivers)</label>
                  <app-number-input
                    [numberInput]="block_allowance.harvest_allowance"
                    (numberInputChange)="
                      countAllowanceChangedHandler($event, 'harvest_allowance')
                    "
                  >
                  </app-number-input>
                </div>
                <div class="fieldwrap label-inline">
                  <label>Harvest Allowance - Tonnes on which it is paid</label>
                  <app-number-input
                    [dataPost]="dataPost.t"
                    [numberInput]="block_allowance.harvest_allowance_tonnes"
                    (numberInputChange)="
                      countAllowanceChangedHandler(
                        $event,
                        'harvest_allowance_tonnes'
                      )
                    "
                  >
                  </app-number-input>
                </div>

                <div class="fieldwrap label-inline">
                  <label>$/t Haulage Allowance (not paid to drivers)</label>
                  <app-number-input
                    [numberInput]="block_allowance.haulage_allowance"
                    (numberInputChange)="
                      countAllowanceChangedHandler($event, 'haulage_allowance')
                    "
                  >
                  </app-number-input>
                </div>
                <div class="fieldwrap label-inline">
                  <label>Haulage Allowance - Tonnes on which it is paid</label>
                  <app-number-input
                    [numberInput]="block_allowance.haulage_allowance_tonnes"
                    (numberInputChange)="
                      countAllowanceChangedHandler(
                        $event,
                        'haulage_allowance_tonnes'
                      )
                    "
                  >
                  </app-number-input>
                </div>

                <div class="fieldwrap label-inline">
                  <label>$/t Night Allowance (not paid to drivers)</label>
                  <app-number-input
                    [numberInput]="block_allowance.night_allowance"
                    (numberInputChange)="
                      countAllowanceChangedHandler($event, 'night_allowance')
                    "
                  >
                  </app-number-input>
                </div>
                <div class="fieldwrap label-inline">
                  <label>Night Allowance - Tonnes on which it is paid</label>
                  <app-number-input
                    [numberInput]="block_allowance.night_allowance_tonnes"
                    (numberInputChange)="
                      countAllowanceChangedHandler(
                        $event,
                        'night_allowance_tonnes'
                      )
                    "
                  >
                  </app-number-input>
                </div>

                <div class="fieldwrap label-inline">
                  <label>$/t Sunday Allowance (not paid to drivers)</label>
                  <app-number-input
                    [numberInput]="block_allowance.sunday_allowance"
                    (numberInputChange)="
                      countAllowanceChangedHandler($event, 'sunday_allowance')
                    "
                  >
                  </app-number-input>
                </div>
                <div class="fieldwrap label-inline">
                  <label>Sunday Allowance - Tonnes on which it is paid</label>
                  <app-number-input
                    [numberInput]="block_allowance.sunday_allowance_tonnes"
                    (numberInputChange)="
                      countAllowanceChangedHandler(
                        $event,
                        'sunday_allowance_tonnes'
                      )
                    "
                  >
                  </app-number-input>
                </div>
              </div>

              <div class="total-wrap h6">
                <span
                  >Average allowance per tonne for representative
                  block/area</span
                >
                <div class="total">
                  <span>{{
                    block_allowance.total_average_allowance_per_tone
                      | number : "1.2-2"
                  }}</span>
                </div>
              </div>

              <div class="fieldwrap fieldwrap-type-submit">
                <button
                  class="btn__secondary close-modal"
                  type="button"
                  (click)="allowance_open = false"
                >
                  Close
                </button>
                <button
                  class="btn-save"
                  type="submit"
                  (click)="saveBlockAllowance()"
                >
                  Save
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
      <div id="calcularions" [ngClass]="{ 'overlay open': dialog_open }">
        <div class="modal-box" style="width: 80%">
          <button
            class="close"
            type="button"
            (click)="dialog_open = false"
          ></button>
          <div class="modal-header">
            <h2>Block Calculation Results</h2>
            <h4>Select A Practice</h4>
            @if (mlModelVersion) {
            <div style="margin-top: 4px">
              <span
                style="
                  background-color: #1976d2;
                  color: white;
                  padding: 2px 8px;
                  border-radius: 4px;
                  font-size: 12px;
                "
              >
                ML {{ mlModelVersion }}
              </span>
            </div>
            }
            <!-- SRA003-514: yield-source banner (extends the SRA003-475 notice). -->
            @if (yieldSourceBanner; as banner) {
            <div
              class="ml-fallback-notice"
              [class.ml-source-info]="banner.tone === 'info'"
              style="margin-top: 4px"
            >
              <span>{{ banner.tone === 'warn' ? '⚠ ' : '' }}{{ banner.text }}</span>
            </div>
            }
          </div>
          <div class="hours-filter" style="padding: 4px 0 10px">
            <label for="maxWorkingHours" style="margin-right: 6px">
              Max working hours/day
            </label>
            <input
              id="maxWorkingHours"
              type="number"
              min="0"
              step="0.5"
              [(ngModel)]="maxWorkingHours"
              [ngModelOptions]="{ standalone: true }"
            />
            @if (isHoursFilterFallback) {
            <span style="margin-left: 8px; color: #666; font-size: 12px">
              No scenarios within {{ maxWorkingHours }} h/day — showing all.
            </span>
            }
          </div>
          <!-- SRA003-468/-469: the BE-owned optimality trim (is_optimal),
               exposed as a visible toggle. Off shows the full sweep. -->
          <div class="benefit-filter" style="padding: 0 0 10px">
            <input
              id="showOptimalOnly"
              type="checkbox"
              [(ngModel)]="showOptimalOnly"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onOptimalFilterToggle()"
            />
            <label for="showOptimalOnly" style="margin-left: 6px">
              Show optimal scenarios only
            </label>
            @if (isBenefitTrimEmpty) {
            <span style="margin-left: 8px; color: #666; font-size: 12px">
              No optimal scenarios to show — Standard Practice only. Turn this
              off for the full sweep.
            </span>
            }
          </div>
          <form>
            <fieldset>
              <div class="flex-container">
                <div class="frozen-box">
                  <table>
                    <tr>
                      <td colspan="2"><strong>Measurements</strong></td>
                    </tr>
                    <tr>
                      <td><strong>Grower Net benefit: ($/ha)</strong></td>
                    </tr>
                    <tr>
                      <td>Yield (t/ha):</td>
                    </tr>
                    <tr>
                      <td>Yield Change (t/ha):</td>
                    </tr>
                    <tr>
                      <td>CCS:</td>
                    </tr>
                    <tr>
                      <td>Topping:</td>
                    </tr>
                    <tr>
                      <td>Ground Speed (km/hr):</td>
                    </tr>
                    <tr>
                      <td>Fan Speed (RPM):</td>
                    </tr>
                    <tr>
                      <td>Hours per day (total):</td>
                    </tr>
                    <tr>
                      <td>Hours per day (cutting):</td>
                    </tr>
                    <tr>
                      <td colspan="2">Total area harvested (ha):</td>
                    </tr>
                    <tr>
                      <td>Flow Rate (t/hr):</td>
                    </tr>
                    <tr>
                      <td>Bin Weight (t/bin):</td>
                    </tr>
                    <tr>
                      <td>Cost Change ($/t):</td>
                    </tr>
                    <tr>
                      <td>Cost Change ($/hr):</td>
                    </tr>
                    <tr>
                      <td>Cost Change ($/ha):</td>
                    </tr>
                  </table>
                </div>
                @if (block_results[0]) {
                <div class="frozen-box">
                  <table
                    (click)="selectThisResult(block_results[0], 0)"
                    style="cursor: pointer"
                  >
                    <tr>
                      <td colspan="2"><strong>Standard Practice</strong></td>
                    </tr>
                    <tr>
                      <td>N/A</td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          block_results[0].block_agronomic_results.yield_std
                            | number : "1.1-1"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>N/A</td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          block_results[0].block_agronomic_results.ccs_std * 100
                            | number : "1.2-2"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ payload.std_topping }}</td>
                    </tr>

                    <tr>
                      <td>
                        {{
                          block_results[0].block_agronomic_results
                            .ground_speed_std | number : "1.1-1"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          block_results[0].block_agronomic_results.fan_speed_std
                            | number : "1.0-0"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          block_results[0].block_agronomic_results
                            .hours_per_day_total_std | number : "1.1-1"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          block_results[0].block_agronomic_results
                            .hours_per_day_cutting_std | number : "1.1-1"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          block_results[0].block_agronomic_results
                            .total_area_harvested | number : "1.0-0"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          block_results[0].block_agronomic_results.flow_rate_std
                            | number : "1.1-1"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          block_results[0].block_agronomic_results
                            .bin_weight_std | number : "1.1-1"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>N/A</td>
                    </tr>
                    <tr>
                      <td>N/A</td>
                    </tr>
                    <tr>
                      <td>N/A</td>
                    </tr>
                  </table>
                </div>
                } @if (block_results.length == 1) {
                <div style="padding: 50px">
                  <div>
                    There are no predicated practices better than the standard
                    practice.
                  </div>
                </div>
                } @if (block_results.length > 1) {
                <div class="scrolling-box">
                  @for (result of block_results; track result; let i = $index) {
                  <div class="scrolling-content">
                    @if (!result.standard && isScenarioShown(result)) {
                    <table
                      (click)="selectThisResult(result, i)"
                      style="cursor: pointer"
                    >
                      <ng-container>
                        <tr>
                          @if (result.standard) {
                          <td colspan="2"><strong>Standard</strong></td>
                          } @if (!result.standard) {
                          <td colspan="2">
                            <strong>({{ rankings[i] }}) Predicted</strong>
                          </td>
                          }
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              {{
                                result.block_economic_results_grower.net_benefit
                                  | number : "1.0-0"
                              }}</strong
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              block_results[i].block_agronomic_results
                                .yield_pred | number : "1.1-1"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              result.block_agronomic_results.yield_change_pred
                                | number : "1.1-1"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              block_results[i].block_agronomic_results
                                .ccs_pred * 100 | number : "1.2-2"
                            }}
                          </td>
                        </tr>
                        <tr>
                          @if (result.standard) {
                          <td>{{ payload.std_topping }}</td>
                          } @if (!result.standard) {
                          <td>
                            {{
                              block_results[i].block_agronomic_results
                                .pred_topping
                            }}
                          </td>
                          }
                        </tr>
                        <tr>
                          <td>
                            {{
                              block_results[i].block_agronomic_results
                                .ground_speed_pred | number : "1.1-1"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              block_results[i].block_agronomic_results
                                .fan_speed_pred | number : "1.0-0"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              block_results[i].block_agronomic_results
                                .hours_per_day_total_pred | number : "1.1-1"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              block_results[i].block_agronomic_results
                                .hours_per_day_cutting_pred | number : "1.1-1"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              block_results[i].block_agronomic_results
                                .total_area_harvested | number : "1.0-0"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              block_results[i].block_agronomic_results
                                .flow_rate_pred | number : "1.1-1"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              block_results[i].block_agronomic_results
                                .bin_weight_pred | number : "1.1-1"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              result.block_economic_results_grower.cost_change_t
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              result.block_economic_results_grower
                                .cost_change_hr
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                              result.block_economic_results_grower
                                .cost_change_ha
                            }}
                          </td>
                        </tr>
                      </ng-container>
                    </table>
                    }
                  </div>
                  }
                </div>
                }
              </div>
              <div class="fieldwrap fieldwrap-type-submit">
                <button
                  class="btn__secondary close-modal"
                  type="button"
                  (click)="dialog_open = false"
                >
                  Close
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
      <div
        id="calculate_average"
        [ngClass]="{ 'overlay open': average_dialog_open }"
      >
        <div class="modal-box">
          <button
            class="close"
            type="button"
            (click)="average_dialog_open = false"
          ></button>
          <div class="modal-header">
            <h2>Block Calculation Results (Avg)</h2>
          </div>
          <form>
            <fieldset>
              <table style="width: 100%" style="cursor: pointer">
                <tr>
                  <td>
                    Yield (t/ha):
                    {{
                      avg_yield_pred / total_selected_blocks | number : "1.1-1"
                    }}
                  </td>
                  <td>
                    Fan Speed(RPM):
                    {{
                      avg_fan_speed_pred / total_selected_blocks
                        | number : "1.0-0"
                    }}
                  </td>
                  <td>
                    Ground Speed (km/hr):
                    {{
                      avg_ground_speed_pred / total_selected_blocks
                        | number : "1.1-1"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Flow Rate (t/hr):
                    {{
                      flow_rate_pred / total_selected_blocks | number : "1.1-1"
                    }}
                  </td>
                  <td>
                    Hours per day (total):
                    {{
                      hours_per_day_total_pred / total_selected_blocks
                        | number : "1.1-1"
                    }}
                  </td>
                  <td>
                    Average Bin Weight (t):
                    {{
                      bin_weight_pred / total_selected_blocks | number : "1.1-1"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Cost Change ($/t):
                    {{
                      total_cost_change_t / total_selected_blocks
                        | number : "1.2-2"
                    }}
                  </td>
                  <td>
                    Cost Change ($/ha):
                    {{
                      total_cost_change_ha / total_selected_blocks
                        | number : "1.0-0"
                    }}
                  </td>
                  <td>
                    Cost Change ($/hr):
                    {{
                      total_cost_change_hr / total_selected_blocks
                        | number : "1.0-0"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Grower Net benefit: $
                    {{
                      avg_net_benefit / total_selected_blocks | number : "1.0-0"
                    }}
                  </td>
                </tr>
              </table>

              <div class="fieldwrap fieldwrap-type-submit">
                <button
                  class="btn__secondary close-modal"
                  type="button"
                  (click)="average_dialog_open = false"
                >
                  Close
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</form>
